module.exports = __webpack_public_path__ + "static/media/undraw_welcome_re_h3d9.9379fdac.svg";